import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "./context/AuthContext";
import ProtectedRoute from "./components/ProtectedRoute";
import ScrollToTop from "./components/ScrollToTop";
import { Loader2 } from "lucide-react";

import Home from "./pages/Home";
import CommonNumber from "./pages/CommonNumber";
import PreviousResult from "./pages/PreviousResult";
import DreamNumber from "./pages/DreamNumber";
import GameResult from "./pages/GameResult";
import { AboutUs, ContactUs, PrivacyPolicy, TermsAndConditions, Disclaimer } from "./pages/StaticPages";

import AdminLogin from "./pages/AdminLogin";
import AdminDashboard from "./pages/AdminDashboard";
import ManageResult from "./pages/admin/ManageResult";
import ChangePassword from "./pages/admin/ChangePassword";

function AdminGate() {
  const { user } = useAuth();
  if (user === null) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-slate-900">
        <Loader2 className="animate-spin text-red-500" size={32} />
      </div>
    );
  }
  if (user) return <Navigate to="/admin/dashboard" replace />;
  return <AdminLogin />;
}

function App() {
  return (
    <AuthProvider>
      <Toaster position="top-center" richColors />
      <BrowserRouter>
        <ScrollToTop />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/common-number" element={<CommonNumber />} />
          <Route path="/common-number/:game" element={<CommonNumber />} />
          <Route path="/dream-number" element={<DreamNumber />} />
          <Route path="/previous-result" element={<PreviousResult />} />
          <Route path="/previous-result/:game" element={<PreviousResult />} />
          <Route path="/result/:game" element={<GameResult />} />
          <Route path="/about-us" element={<AboutUs />} />
          <Route path="/contact-us" element={<ContactUs />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/terms-and-conditions" element={<TermsAndConditions />} />
          <Route path="/disclaimer" element={<Disclaimer />} />

          <Route path="/admin" element={<AdminGate />} />
          <Route path="/admin/dashboard" element={<ProtectedRoute><AdminDashboard /></ProtectedRoute>} />
          <Route path="/admin/results" element={<ProtectedRoute><ManageResult /></ProtectedRoute>} />
          <Route path="/admin/change-password" element={<ProtectedRoute><ChangePassword /></ProtectedRoute>} />

          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
